// extracted by mini-css-extract-plugin
export default {"vgIFrame":"NewsPage_vgIFrame__S-dYe"};